import * as React from 'react';
const SvgRunning = props => (
  <svg xmlns='http://www.w3.org/2000/svg' width={800} height={800} fill='none' viewBox='0 0 24 24' {...props}>
    <path
      fill={props.fill || '#0F0F0F'}
      d='M18.5 6a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM9.5 3.938 7.47 5.206c-.357.224-.47.593-.47.99a1 1 0 0 0 1.53.848l1.889-1.18a1 1 0 0 1 1.13.047L13 7l-3.707 3.707a4.998 4.998 0 0 0-.534.63l-1.813 2.538a1 1 0 0 1-1.165.355l-2.57-.964A.956.956 0 0 0 2.416 15l2.472 1.349a3 3 0 0 0 3.694-.659L10.5 13.5l1.8 2.52a2 2 0 0 1 .161 2.057l-1.737 3.476A1 1 0 0 0 11.618 23c.47 0 .924-.083 1.158-.553l1.972-3.942a3 3 0 0 0-.14-2.932L13 13l3-3 1.372.915c1.235.823 2.601.76 3.944.313.465-.155.684-.583.684-1.047a1 1 0 0 0-1.164-.987c-.69.115-1.69.5-2.2-.18-1.67-2.227-3.641-3.795-6.09-5.155a3 3 0 0 0-3.046.079Z'
    />
  </svg>
);
export default SvgRunning;
